// @ts-nocheck
import React, {useEffect, useRef, useState} from "react";
import JoyrideCustomTooltip from "./JoyrideCustomTooltip";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {OnBoardingStep} from "../../Interfaces/OnBoardingStep";
import {addOnBoardingShownStep, setOnBoardingShow, setOnBoardingStep} from "../../store/makerDataSlice";
import {store} from "../../store/store";


interface OnBoardingProps {
}

const onBoardingSteps = {
    [OnBoardingStep.themes]: [
        {
            target: '#makeTabs-tabpane-themes .theme-item:first-child',
            content: 'Это шаблоны слайд-шоу.<br> <b>Нажмите</b>, чтобы посмотреть.<br> <b>Выберите подходящий</b>, в него мы вставим Ваши фотографии и текст.',
            disableBeacon: true,
            placement: 'bottom'
        }
    ],
    [OnBoardingStep.slides]: [
        {
            target: '#makeTabs-tabpane-slides .add-slide-item',
            content: '<b>Загрузите</b> свои фотографии и <b>добавьте текст</b>.<br><br><b>Длительность</b> готового видео зависит от <b>количества слайдов</b> и <b>выбранной темы</b>.',
            disableBeacon: true
        },
        {
            target: '#makeTabs-tabpane-slides .slides-grid>div:nth-last-child(2)',
            content: 'Добавленные слайды можно <b>передвигать</b>, <b>удалять</b> и поворачивать.',
            disableBeacon: true
        },
        /**
         * Перенёс текст "Длительность готового видео..." в первый шаг, в попытке решить проблему что у некоторых пользователей
         * при открытии редактора с открытки onBoarding съезжает вниз, делая высоту страницы 15000px и всё разъезжается
         * Непонятно из-за чего это возникает и в каких случаях, есть гипотеза что из-за position:fixed у .footer-buttons
         * и из-за того, что шаг "Длительность готового видео..." нацелен на элемент внутри .footer-buttons
         * Попробуем.
         */
        // {
        //     target: '.footer-buttons.slides .video-duration.video-duration-top>span',
        //     content: '<b>Длительность</b> готового видео зависит от <b>количества слайдов</b> и <b>выбранной темы</b>.',
        //     disableBeacon: true
        // },
        // {
        //     target: '.footer-buttons.slides .video-duration.video-duration-right>span',
        //     content: '<b>Длительность</b> готового видео зависит от <b>количества слайдов</b> и <b>выбранной темы</b>.',
        //     disableBeacon: true
        // }
    ],
    [OnBoardingStep.slidesAddPopup]: [
        {
            target: '.add-slides-popup .nav-tabs .nav-item:nth-child(1)',
            content: '<b>Загрузите</b> одну или <b>сразу несколько</b> фотографий.',
            disableBeacon: true,
            disableScrolling: true,
            placement: 'bottom'
        },
        {
            target: '.add-slides-popup .nav-tabs .nav-item:nth-child(2)',
            content: 'Добавьте <b>текстовый слайд</b>.<br> Это могут быть поздравления, пожелания или просто тёплые слова.',
            disableBeacon: true,
            disableScrolling: true,
            placement: 'bottom'
        }
    ],
    [OnBoardingStep.music]: [
        {
            target: '#makeTabs-tabpane-music .upload-sound-btn',
            content: '<b>Загрузите</b> свою музыку (mp3 файл).',
            disableBeacon: true,
            placement: 'bottom'
        },
        {
            target: '#makeTabs-tabpane-music .music-list.popular .music-item:first-child',
            content: 'Или <b>выберите</b> одну из наших мелодий.',
            disableBeacon: true,
            placement: 'bottom'
        },
        {
            target: '#makeTabs-tabpane-music .music-list.popular .music-item:first-child .duration',
            content: 'Если готовое <b>видео длиннее</b> мелодии, <br>мелодия в видео <b>прозвучит ещё раз</b>.',
            disableBeacon: true
        }
    ],
    [OnBoardingStep.payment]: [
        {
            target: '#makeTabs-tabpane-payment .stub-generation-in-progress .text-1',
            content: 'Сейчас мы создаём <b>макет видео</b> — первые 5 слайдов, в низком качестве.<br> Это недолго, нам нужно 1-2 минуты.',
            disableBeacon: true,
            placement: 'bottom'
        },
        {
            target: '#makeTabs-tabpane-payment .stub-height',
            content: 'Это <b>макет видео</b> — первые 5 слайдов, в низком качестве.<br> Посмотрите его, чтобы понять, как будет выглядеть Ваше видео.',
            disableBeacon: true,
            placement: 'bottom'
        },
        {
            target: '#makeTabs-tabpane-payment .btn-back-to-slides',
            content: 'Вы можете <b>вернуться назад</b>, чтобы выбрать <b>другую тему</b> или добавить <b>слайды</b>.',
            disableBeacon: true,
            placement: 'top'
        },
        {
            target: '#makeTabs-tabpane-payment .email-form-block .btn-primary',
            content: 'Последний шаг — <b>заказ полного видео</b>, со всеми слайдами, в хорошем качестве.<br> После оплаты, мы <b>сразу начинаем делать</b> полное видео, в автоматическом режиме.',
            disableBeacon: true,
            placement: 'top'
        }
    ]
}

const setStepTimeout = {
    id: null,
};

const OnBoarding: React.FC<OnBoardingProps> = ({}) => {

    // чтобы установить state внутри setTimeout, useState не подходит, поэтому используем useRef как лайфхак для хранения данных
    // https://felixgerschau.com/react-hooks-settimeout/
    const stepsRef = useRef([]);

    const [stepIndex, setStepIndex] = useState(0);
    const [stepAutoplayTimeout, setStepAutoplayTimeout] = useState(null);
    const [doAutoplay, setDoAutoplay] = useState(true);
    const [run, setRun] = useState(true);

    const makerData = useAppSelector(state => state.makerData)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!makerData.isLoadedAndInitialized) {
            return;
        }
        switch (makerData.currentTab) {
            case 'themes':
                dispatch(setOnBoardingStep(OnBoardingStep.themes));
                break;
            case 'slides':
                dispatch(setOnBoardingStep(OnBoardingStep.slides));
                break;
            case 'music':
                dispatch(setOnBoardingStep(OnBoardingStep.music));
                break;
            case 'payment':
                if (makerData.previewData !== null && makerData.slidesNumReady >= 2) {
                    dispatch(setOnBoardingStep(OnBoardingStep.payment));
                }
                break;
        }
    }, [makerData.currentTab, makerData.isLoadedAndInitialized, makerData.previewData])

    useEffect(() => {
        if (!makerData.isLoadedAndInitialized) {
            return;
        }
        if (makerData.isAddSlidePopupOpen) {
            dispatch(setOnBoardingStep(OnBoardingStep.slidesAddPopup));
        }
    }, [makerData.currentTab, makerData.isAddSlidePopupOpen])

    useEffect(() => {
        // если ещё не показывали этот шаг
        stepsRef.current = [];
        if (!makerData.onBoardingStepsShown.includes(makerData.onBoardingStep)) {

            if (setStepTimeout.id !== null) clearTimeout(setStepTimeout.id);
            setStepTimeout.id = setTimeout(() => {
                // только такой вариант работает внутри setInterval, только так можем
                // получить актуальный state при каждом цикле interval'а
                const makerDataFromSetTimeout = store.getState().makerData;
                if (makerDataFromSetTimeout.onBoardingStep === '' || typeof makerDataFromSetTimeout.onBoardingStep === 'undefined') {
                    return;
                }

                let steps = JSON.parse(JSON.stringify(onBoardingSteps[makerDataFromSetTimeout.onBoardingStep]));

                // если tab "Слайды" - смотрим, есть ли загруженные слайды, если нет - то пропускаем подсказку
                // и смотрим какую подсказку "Длительность видео" показать, в зависимости от ширины экрана
                if (makerDataFromSetTimeout.onBoardingStep === OnBoardingStep.slides) {
                    // Если узкий экран - video-duration-right display=none, не показываем над ним подсказку
                    if (document.getElementById('video-duration-right')?.offsetParent === null) {
                        steps.splice(3, 1); // убираем 1 элемент (второй аргумент) с индексом 3 (первый аргумент)
                    }
                    // Если широкий экран - video-duration-top display=none, не показываем над ним подсказку
                    if (document.getElementById('video-duration-top')?.offsetParent === null) {
                        steps.splice(2, 1); // убираем 1 элемент (второй аргумент) с индексом 2 (первый аргумент)
                    }
                    // нет загруженных слайдов - убираем шаг с подсказкой
                    if (makerData.slides?.length === 1) {
                        steps.splice(1, 1); // убираем 1 элемент (второй аргумент) с индексом 1 (первый аргумент)
                    }
                }

                // если tab "Оплата"
                if (makerDataFromSetTimeout.onBoardingStep === OnBoardingStep.payment) {
                    // Если нет заглушки "Генерируем видео" - убираем эту подсказку
                    if (!document.querySelector("#makeTabs-tabpane-payment .stub-generation-in-progress .text-1")) {
                        steps.splice(0, 1); // убираем 1 элемент (второй аргумент) с индексом 0 (первый аргумент)
                    } else {
                        steps.splice(1, 1); // убираем 1 элемент (второй аргумент) с индексом 1 (первый аргумент)
                    }
                }

                setStepIndex(0);
                stepsRef.current = steps;
                dispatch(addOnBoardingShownStep(makerDataFromSetTimeout.onBoardingStep));
                setRun(true)
            }, 300);
        }
    }, [makerData.onBoardingStep, makerData.onBoardingResetTime])

    return (
        makerData.onBoardingShow ?
            <Joyride
                key={JSON.stringify(stepsRef.current)}
                run={run}
                continuous={true}
                scrollDuration={300}
                scrollOffset={window.innerHeight / 3}
                disableScrolling={false}
                // disableOverlay={true}
                showSkipButton={true}
                showProgress={true}
                locale={{
                    back: 'Назад',
                    close: 'Закрыть',
                    last: 'Понятно',
                    next: 'Далее',
                    open: 'Открыть',
                    skip: 'Больше не показывать'
                }}
                // @ts-ignore
                tooltipComponent={JoyrideCustomTooltip}
                steps={stepsRef.current}
                stepIndex={stepIndex}
                callback={(callbackProps) => {

                    /**
                     * Ручное переключение между шагами и autoplay
                     */
                    if ((callbackProps.action == ACTIONS.NEXT || callbackProps.action == ACTIONS.PREV) &&
                        (callbackProps.type == EVENTS.STEP_AFTER || callbackProps.type == EVENTS.TARGET_NOT_FOUND)) {
                        const newStepIndex = callbackProps.index + (callbackProps.action == ACTIONS.PREV ? -1 : 1);
                        setStepIndex(newStepIndex);
                        if (callbackProps.action == ACTIONS.NEXT || callbackProps.action == ACTIONS.PREV) {
                            if (stepAutoplayTimeout !== null) {
                                document.querySelector('.react-joyride__tooltip button[data-test-id="button-primary"]')?.classList.remove('autoplay');
                                clearTimeout(stepAutoplayTimeout);
                            }
                        }
                        if (callbackProps.action == ACTIONS.PREV) {
                            setDoAutoplay(false);
                        }
                        if (callbackProps.action == ACTIONS.NEXT) {
                            if (doAutoplay) {
                                setTimeout(() => {
                                    document.querySelector('.react-joyride__tooltip button[data-test-id="button-primary"]')?.classList.add('autoplay');
                                }, 300);
                                setStepAutoplayTimeout(
                                    setTimeout(() => {
                                        setStepIndex(newStepIndex + 1);
                                    }, 10300)
                                );
                            }
                        }
                    }
                    if (callbackProps.action === 'start' && callbackProps.lifecycle === 'ready' && callbackProps.type == EVENTS.STEP_BEFORE)
                    {
                        if (stepAutoplayTimeout !== null) {
                            document.querySelector('.react-joyride__tooltip button[data-test-id="button-primary"]')?.classList.remove('autoplay');
                            clearTimeout(stepAutoplayTimeout);
                        }
                        if (doAutoplay) {
                            document.querySelector('.react-joyride__tooltip button[data-test-id="button-primary"]')?.classList.add('autoplay');
                            setStepAutoplayTimeout(
                                setTimeout(() => {
                                    setStepIndex(1);
                                }, 10300)
                            );
                        }
                    }
                    /**
                     * END ручное переключение между шагами и autoplay
                     */

                    // когда табы становятся sticky - они уменьшаются по высоте, чтоб немного сводит с ума onBoarding
                    // при scroll'е между элементами.
                    // убираем изменение высоты tab'ов, если идёт onBoarding
                    if (callbackProps.action === 'start' && callbackProps.lifecycle === 'init' && callbackProps.size > 0) {
                        document.querySelector('.make-app .tabs .nav-tabs')?.classList.add('on-boarding-active');
                        document.querySelector('#makeTabs-tabpane-music .music-container .music-player')?.classList.add('on-boarding-active');
                    }
                    if (callbackProps.action === 'skip' || callbackProps.action === 'stop' || callbackProps.action === 'reset' || callbackProps.action === 'close') {
                        document.querySelector('.make-app .tabs .nav-tabs')?.classList.remove('on-boarding-active');
                        document.querySelector('#makeTabs-tabpane-music .music-container .music-player')?.classList.remove('on-boarding-active');
                        dispatch(setOnBoardingStep(''))
                    }

                    // при нажатии на крестик или click outside - выключаем onBoarding
                    if (callbackProps.action === 'close' && (callbackProps.lifecycle === 'ready' || callbackProps.lifecycle == 'complete')) {
                        if (stepAutoplayTimeout !== null) {
                            clearTimeout(stepAutoplayTimeout);
                        }
                        setRun(false);
                    }
                    // при нажатии на Больше не показывать
                    if (callbackProps.action === 'skip') {
                        if (stepAutoplayTimeout !== null) {
                            clearTimeout(stepAutoplayTimeout);
                        }
                        dispatch(setOnBoardingShow(false));
                    }

                    // Слайды, подсказка на загруженном слайде
                    if (callbackProps?.step?.target === '#makeTabs-tabpane-slides .slides-grid>div:nth-last-child(2)') {
                        // показываем и скрываем hover блок над загруженным слайдом (повернуть/удалить/переместить)
                        if (callbackProps.action === 'update') {
                            document.querySelector("#makeTabs-tabpane-slides .slides-grid>div:nth-last-child(2)")?.classList.add("hover");
                        }
                        if (callbackProps.action === 'close' || callbackProps.action === 'next' || callbackProps.action === 'skip') {
                            document.querySelector("#makeTabs-tabpane-slides .slides-grid>div:nth-last-child(2)")?.classList.remove("hover");
                        }
                    }
                }
                }
            /> : ''
    );
}

export default OnBoarding;